module.exports = __webpack_public_path__ + "img/AI-SPEAK-01.3ed2660a.png";